import React from 'react';
import { Alert } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';

interface VehicleDefectsSectionProps {
  vehicle: Vehicle;
}

const VehicleDefectsSection: React.FC<VehicleDefectsSectionProps> = ({ vehicle }) => {
  return (
    <div>
      <h2>Vehicle Defects</h2>
      <Alert variant="info">
        <i className="bi bi-info-circle tw-mr-2"></i>
        This feature is not yet developed.
      </Alert>
    </div>
  );
};

export default VehicleDefectsSection;

